import React from 'react';
import { formatNumber } from '../../utils/funtions';
const CustomCellRender = ({
  prefix,
  text,
  justify,
  style = {},
  allowNull = false,
}) => {
  return (
    <div
      style={{
        ...{
          display: 'flex',
          justifyContent: justify,
          width: '100%',
        },
        ...style,
      }}
    >
      <div>{prefix}</div>
      <div>{formatNumber(text, allowNull)}</div>
    </div>
  );
};
export default CustomCellRender;
